import axios from 'axios';
import qs from 'qs';

// 兼容没有 commonObj 的情况，比如 PC 端页面
// 所以这里不采用 import 方式
const commonObj = window.commonObj || {};

// 创建axios实例
const instance = axios.create({
  timeout: 30000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  transformRequest: [function(data, headers) {
    if (data instanceof FormData) {
      return data;
    }

    if (data?.__json__ === true) {
      headers['Content-Type'] = 'application/json; charset=utf-8';
      data.__json__ = undefined;

      return JSON.stringify(data);
    }

    return qs.stringify(data);
  }]
});

// request拦截器
instance.interceptors.request.use(config => {
  if (config.method === 'get') {
    config.params = config.data;
  }

  return config;
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
});

export default function(url, inputOptions = {}) {
  const options = { ...inputOptions };

  if (!options.method) {
    options.method = 'get';
  }

  if (options.upload === true) {
    const fd = new FormData();

    options.data.userid = commonObj.data?.userid;
    options.data.token = commonObj.data?.token;

    for (const key in options.data) {
      if (Object.prototype.hasOwnProperty.call(options.data, key)) {
        const value = options.data[key];

        if (value === undefined) {
          continue;
        }

        if (Array.isArray(value)) {
          value.forEach((item) => {
            fd.append(`${key}[]`, item);
          });
        }
        else {
          fd.append(key, value);
        }
      }
    }

    options.data = fd;
  }
  else if (options.method === 'post' && options.json === true) {
    if (options.data) {
      options.data.__json__ = true;
    }
  }

  if (!options.data) {
    options.data = {};
  }

  if (options.method.toLowerCase() === 'get' && options.cache !== true) {
    options.data._ = String(+new Date()) + String(Math.floor(Math.random() * 9999));
  }

  if (!options.data.userid) {
    options.data.userid = commonObj.data?.userid;
  }
  if (!options.data.token) {
    options.data.token = commonObj.data?.token;
  }

  if (!options.onUploadProgress && options.onUploadPercent) {
    options.onUploadProgress = (progressEvent) => {
      if (progressEvent.lengthComputable) {
        options.onUploadPercent(Math.floor((progressEvent.loaded / progressEvent.total) * 100), progressEvent);
      }
    }
  }

  return instance(url, options)
    .then((response) => {
      let data = response.data;

      if (!data) {
        data = {};
      }

      data.$response = response;

      return data;
    })
    .catch((error) => {
      return {
        code: -99999,
        data: {},
        msg: error.message,
        $response: error
      };
    });
};
